import React, { useState } from 'react';

const TruncatedMessage = ({ text = '', maxLength = 3 }) => {
  const [isTruncated, setIsTruncated] = useState(true);
  const safeText = typeof text === 'string' ? text : text == null ? '' : String(text);

  const toggleTruncation = () => {
    setIsTruncated((currentValue) => !currentValue);
  };

  if (safeText.length <= maxLength) {
    return <span>{safeText}</span>;
  }

  return (
    <div className="truncated-message">
      <span className="truncated-message__text">{isTruncated ? `${safeText.slice(0, maxLength)}...` : safeText}</span>
      <button type="button" onClick={toggleTruncation} className="truncated-message__button">
        {isTruncated ? 'Show more' : 'Show less'}
      </button>
    </div>
  );
};

export default TruncatedMessage;
